// ticketStatus: 1-处理中 2-已完成 3-已终止
// mtlVerifyStatus: 1-待提交 2-审核中 3-审核不通过 4-审核通过 5-审核终止 6-审核中
// auditStatus: 1-待提交 2-审核中 3-审核不通过 4-审核通过 5-审核终止
export function parseAuditStatus (ticketStatus, mtlVerifyStatus) {
  if (ticketStatus === 3) {
    // 3-x 审核终止
    return 5
  } else if (ticketStatus === 2) {
    if ([3, 4, 5].includes(mtlVerifyStatus)) {
      // 2-4 审核通过 2-5 审核终止 2-3 兼容申诉记录 1-3 2-5 -> 2-3
      return mtlVerifyStatus
    }
  } else if (ticketStatus === 1) {
    if (mtlVerifyStatus < 4) {
      return mtlVerifyStatus
    } else if (mtlVerifyStatus === 4) {
      // 1-4 1-6 审核中
      return 2
    } else if (mtlVerifyStatus === 6) {
      return 5
    }
  }
  return ''
}
